import { render, staticRenderFns } from "./AscMxRecDetail.vue?vue&type=template&id=36033f9c&"
import script from "./AscMxRecDetail.vue?vue&type=script&lang=js&"
export * from "./AscMxRecDetail.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports